import { useState } from 'react';

import { SendoutsContext } from '@app/providers/SendoutsProvider/SendoutsContext';
import type { NSendoutsProvider } from '@app/providers/SendoutsProvider/SendoutsProvider.types';
import { useRegistryFilterState } from '@app/shared/hooks';

import type { Options } from '@pages/Sendouts/SendoutsList/types';

import type { BaseOptionType } from 'antd/es/select';

export const SendoutsProvider: NSendoutsProvider.Main = ({ children }) => {
  // Поиск и выбранные фильтры переживают уход на другой раздел бокового меню
  // и возврат обратно (issue/11161): хранилище вкладочное, как у реестра
  // записей и реестра задач. Списки опций каждый раз приходят с бэка и в
  // хранилище не попадают.
  const [searchTerm, setSearchTerm] = useRegistryFilterState<string>(
    'sendouts',
    'searchTerm',
    ''
  );

  const [statusOptions, setStatusOptions] = useState<Options>([]);
  const [channelOptions, setChannelOptions] = useState<Options>([]);
  const [integrationOptions, setIntegrationOptions] = useState<Options>([]);

  const [selectedStatusOptions, setSelectedStatusOptions] =
    useRegistryFilterState<BaseOptionType[]>(
      'sendouts',
      'selectedStatusOptions',
      []
    );
  const [selectedChannelOptions, setSelectedChannelOptions] =
    useRegistryFilterState<BaseOptionType[]>(
      'sendouts',
      'selectedChannelOptions',
      []
    );
  const [selectedIntegrationOptions, setSelectedIntegrationOptions] =
    useRegistryFilterState<BaseOptionType[]>(
      'sendouts',
      'selectedIntegrationOptions',
      []
    );

  return (
    <SendoutsContext.Provider
      value={{
        searchTerm,
        statusOptions,
        channelOptions,
        integrationOptions,
        selectedStatusOptions,
        selectedChannelOptions,
        selectedIntegrationOptions,
        setSearchTerm,
        setStatusOptions,
        setChannelOptions,
        setIntegrationOptions,
        setSelectedStatusOptions,
        setSelectedChannelOptions,
        setSelectedIntegrationOptions,
      }}
    >
      {children}
    </SendoutsContext.Provider>
  );
};
